<template>
  <v-card
    class="elevation-3 dashboard-card"
    ma-3
    max-width="450"
  >
    <v-card-title>
      <h3>{{ title }}</h3>
    </v-card-title>
    <v-card-text>
      <table>
        <tr>
          <td class="left-col">
            {{ $t('message.current_value') }}
          </td>
          <td class="error--text right-col">
            {{ $t('message.target_value') }}
          </td>
        </tr>
        <tr>
          <td class="large left-col">
            {{ formattedValue(values.current) }}
          </td>
          <td class="error--text large right-col">
            {{ formattedValue(values.target) }}
          </td>
        </tr>
        <tr>
          <td class="left-col">
            {{ $t('message.due_date') }} {{ values.date | formatDate }}
          </td>
          <td />
        </tr>
        <tr v-if="true || values.platformCurrent > 0">
          <td class="left-col pt-4">
            {{ $t('message.platform_avg') }}
          </td>
          <td class="error--text right-col pt-4">
            {{ $t('message.platform_avg') }}
          </td>
        </tr>
        <tr v-if="true || values.platformCurrent > 0">
          <td class="left-col middle">
            {{ formattedValue(platformAvgCurrent) }}
          </td>
          <td class="error--text middle right-col">
            {{ formattedValue(platformAvgTarget) }}
          </td>
        </tr>
      </table>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    fractionDigits: {
      type: Number,
      default: 0,
    },
    showDifference: {
      type: Boolean,
      default: false,
    },
    values: {
      type: Object,
      default: () => ({
        current: 0,
        target: 0,
        date: null,
        targetDate: null
      }),
    },
    platformAvgCurrent: {
      type: Number,
      default: 0
    },
    platformAvgTarget: {
      type: Number,
      default: 0
    },
    unit: {
      type: String,
      default: ''
    },
  },
  computed: {},
  methods: {
    formattedValue(v) {
      if (isNaN(v)) return '-'
      else {
        const localizedNum = v.toLocaleString('nl', {
          minimumFractionDigits: this.fractionDigits,
          maximumFractionDigits: this.fractionDigits,
        })
        return this.unit ? this.unit + ' ' + localizedNum : localizedNum
      }
    },
  },
}
</script>
<style lang="less" scoped>
.dashboard-card {
  height: 100%;
  max-width: 400px;
  span,
  div {
    font-size: 0.98rem;
  }
  .large {
    font-size: 2.5rem;
    line-height: 2rem;
    white-space: nowrap;
    padding-right: 10px;
  }
  .middle {
    font-size: 1.7rem;
    line-height: 2.5rem;
    white-space: nowrap;
    padding-right: 10px;
  }
  .right-col {
    padding-left: 10px;
  }
  .left-col {
    padding-right: 10px;
    border-right: 1px solid black;
  }
  table {
    width: 100%;
    border-spacing: 0;
  }
  td {
    width: 50%;
    padding-top: 3px;
    padding-bottom: 3px;
  }
  .v-card__title {
    padding-bottom: 0;
  }
}
</style>
<style lang="less">
@media screen and (max-width: 670px) {
  #UserDashboard div.flex.sm6 {
    -ms-flex-preferred-size: 80%;
    flex-basis: 80%;
    -webkit-box-flex: 0;
    -ms-flex-positive: 0;
    flex-grow: 0;
    max-width: 440px;
    margin: 0 auto;
  }
}
</style>
